var _styled, _styled2;

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

import React, { Fragment } from 'react';
import styled from 'react-emotion';
import PropTypes from 'prop-types';
import { TURQUOISE, WHITE } from 'govuk-colours';
import { withWhiteSpace } from '@govuk-react/hoc';
import { MEDIA_QUERIES, NTA_LIGHT, SPACING } from '@govuk-react/constants';
var StyledPanel = styled('div')({
  backgroundColor: TURQUOISE,
  color: WHITE,
  padding: SPACING.SCALE_5
}); // TODO use standard font constants

var StyledTitle = styled('h2')((_styled = {
  fontFamily: NTA_LIGHT,
  fontWeight: 'bold',
  WebkitFontSmoothing: 'antialiased',
  fontSize: '32px',
  lineHeight: '35px',
  marginTop: 0,
  textAlign: 'center'
}, _styled[MEDIA_QUERIES.LARGESCREEN] = {
  fontSize: '48px',
  lineHeight: '50px'
}, _styled)); // TODO use standard font constants

var StyledBody = styled('div')((_styled2 = {
  fontFamily: NTA_LIGHT,
  fontSize: '24px',
  fontWeight: 400,
  lineHeight: '25px',
  marginTop: SPACING.SCALE_3,
  marginBottom: SPACING.SCALE_2,
  textAlign: 'center',
  WebkitFontSmoothing: 'antialiased'
}, _styled2[MEDIA_QUERIES.LARGESCREEN] = {
  fontSize: '36px',
  lineHeight: '40px'
}, _styled2));
/**
 *
 * ### Usage
 *
 * Simple
 * ```jsx
 * <Panel panelTitle="Application complete" />
 * ```
 *
 * Panel with header and HTML body
 * ```jsx
 * <Panel
 *    panelTitle="Application complete"
 *    panelBody={['Your reference number', <br />, <strong>HDJ2123F</strong>]}
 *  />
 * ```
 *
 * ### References:
 * - https://github.com/alphagov/govuk-frontend/tree/master/src/components/panel
 *
 */

var Panel = function Panel(_ref) {
  var panelTitle = _ref.panelTitle,
      panelBody = _ref.panelBody,
      props = _objectWithoutProperties(_ref, ["panelTitle", "panelBody"]);

  return React.createElement(StyledPanel, props, React.createElement(StyledTitle, null, panelTitle), React.createElement(StyledBody, null, Array.isArray(panelBody) ? panelBody.map(function (element, index) {
    return (
      /* eslint-disable-next-line react/no-array-index-key */
      React.createElement(Fragment, {
        key: index
      }, element)
    );
  }) : panelBody));
};

Panel.defaultProps = {
  panelBody: undefined
};
export default withWhiteSpace({
  marginBottom: 3
})(Panel);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@govuk-react/panel/es/index.js
// module id = 273
// module chunks = 0